import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

export interface NbAppFeatured {
  id: number
  title: string
  date_entered: string
  days_active: number
  description: string
  active?: boolean
  enhanced_tracklist?: boolean
  item_id: number
  item_type: string
  image?: string
  img?: string
  version: string
  mix_title?: string
  dj_name?: string
  lower_left?: string
  lower_right?: string
  last_active_date: string
  last_inactive_date: string
}

export interface NbItem {
  id: number
  title: string
}

export interface NbCarouselsResponse {
  success: boolean
  appsfeatured: NbAppFeatured[]
}

export interface NbCarouselResponse {
  success: boolean
  appfeatured: NbAppFeatured
}

export interface NbItemsResponse {
  success: boolean
  values: NbItem[]
}

export interface NbSuccessResponse {
  success: boolean
}

@Injectable()
export class MusicService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/music/`
  // private ADMIN_ENDPOINT = `${window.location.protocol}//${window.location.host}/adminapi/music/`
  private ADMIN_ENDPOINT = `${environment.HOST}/adminapi/music/`

  constructor(private http: HttpClient) {}

  public getAllCarousels(version: string): Observable<NbCarouselsResponse> {
    return this.http.get(`${this.API_ENDPOINT}getcarousels/version/${version}`).map((res) => res as NbCarouselsResponse)
  }

  public getCarouselByID(id: number): Observable<NbCarouselResponse> {
    return this.http.get(`${this.API_ENDPOINT}getcarousel/id/${id}`).map((res) => res as NbCarouselResponse)
  }

  public saveCarousel(carousel: NbAppFeatured): Observable<NbSuccessResponse> {
    return this.http.post(`${this.API_ENDPOINT}savecarousel/id/${carousel.id}`, carousel).map((res) => res as NbSuccessResponse)
  }

  public deleteCarousel(id: number): Observable<NbSuccessResponse> {
    return this.http.get(`${this.API_ENDPOINT}deletecarousel/id/${id}`).map((res) => res as NbSuccessResponse)
  }

  public toggleCarouselActive(data: any): Observable<any> {
    const endpoint = data.nextValue ? 'activatefeatured' : 'deactivatefeatured'

    return this.http.get(`${this.ADMIN_ENDPOINT}${endpoint}/id/${data.id}`)
  }

  public getItem(type: string): Observable<NbItemsResponse> {
    return this.http.get(`${this.API_ENDPOINT}completefeatured/type/${type}`).map((res) => res as NbItemsResponse)
  }

  public getPartnerItem(): Observable<NbItemsResponse> {
    return this.http.get(`${this.API_ENDPOINT}partnergenres`).map((res) => res as NbItemsResponse)
  }
}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@core/data/music.service.ts